import { getAPIPath, requestGooseAPI } from '../shared/request'
import { BookingReservationClientDto, CreateBookingOrderClientInput, UpdateBookingOrderClientInput } from '../types/api'
import { CLIENT_BOOKING_RESERVATION_ID_PATH, CLIENT_BOOKING_RESERVATION_PATH } from '../types/constants'

export const ClientBookingReservationService = {
  makeReservation: (
    locationName: string,
    data: CreateBookingOrderClientInput
  ): Promise<BookingReservationClientDto | null> => {
    if (data.reservations.length === 0) {
      return Promise.resolve(null)
    }

    return requestGooseAPI<BookingReservationClientDto>({
      url: getAPIPath(CLIENT_BOOKING_RESERVATION_PATH, { locationId: locationName }),
      method: 'POST',
      data,
    })
  },

  updateReservation: (
    orderId: string,
    locationName: string,
    data: UpdateBookingOrderClientInput
  ): Promise<BookingReservationClientDto> => {
    return requestGooseAPI<BookingReservationClientDto>({
      url: getAPIPath(CLIENT_BOOKING_RESERVATION_ID_PATH, { locationId: locationName, id: orderId }),
      method: 'PUT',
      data,
    })
  },
}
